import { StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import { pixelDimensions } from '../../config/utils';
import { appColors } from '../../assets/styles/global';

const styles = StyleSheet.create({
  card: {
    borderColor: appColors.primary,
    borderTopWidth: 5,
    flex: 1,
    justifyContent: 'center',
    backgroundColor: appColors.primary,
  },
  imageLogo: {
    height: pixelDimensions(25),
    width: pixelDimensions(25) * (75 / 22),
  },
  imageSplash: {
    alignSelf: 'center',
    height: pixelDimensions(80),
    width: pixelDimensions(100),
    borderBottomLeftRadius: pixelDimensions(90),
    borderBottomRightRadius: pixelDimensions(90),
  },
  lineCyan: {
    left: -pixelDimensions(20),
    width: pixelDimensions(140),
    backgroundColor: appColors.primary,
    borderBottomWidth: pixelDimensions(5),
    borderBottomColor: appColors.primary,
    borderBottomLeftRadius: pixelDimensions(90),
    borderBottomRightRadius: pixelDimensions(90),
  },
  lineBlue: {
    overflow: 'hidden',
    borderBottomWidth: 0,
    backgroundColor: appColors.primary,
  },
  textSmaller: {
    fontSize: pixelDimensions(6.5),
  },
  textWelcome: {
    textAlign: 'center',
    color: Colors.white,
    fontSize: pixelDimensions(10),
  },
  viewBallContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    paddingVertical: pixelDimensions(5),
  },
  viewBall: {
    backgroundColor: Colors.white,
    width: pixelDimensions(5),
    height: pixelDimensions(5),
    borderRadius: pixelDimensions(50),
    marginHorizontal: pixelDimensions(3),
  },
  viewBallOrange: {
    backgroundColor: Colors.orange700,
  },
  viewBase: {
    flex: 1,
  },
  viewLogo: {
    alignItems: 'center',
    backgroundColor: Colors.white,
    paddingVertical: pixelDimensions(10),
  },
});

export default styles;
